export default "__VITE_ASSET__CSEXyM58__"